import { render, staticRenderFns } from "./sales-executive.vue?vue&type=template&id=2e4cf498"
import script from "./sales-executive.vue?vue&type=script&lang=js"
export * from "./sales-executive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports